import React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { Typography, Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Contact_us from '../../reusable-components/footer/Contactus/Contact_us';
import Statement_of_Privacy from '../../reusable-components/footer/Statement of Privacy/Statement_of_Privacy';
import Terms_and_Conditions from '../../reusable-components/footer/Terms_and_Conditions/Terms_and_Conditions';
import { getisEmp, getOrgType } from '../../utils/Token';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function Help() {
    const isEmployee = getisEmp()
    const hiddentab=getOrgType()=="Admin"?1:getOrgType()=="Client"?1:isEmployee === "true"?2:getOrgType()=="Super Client"?1:2;
    const [value, setValue] = React.useState(hiddentab);

    const handleChange = (event, newValue) => {
        setValue(newValue); 
    };

    const handleFileDownload = () => {
        const fileUrl = `${process.env.PUBLIC_URL}/Client Gen4 site guide V2.pdf`; // Ensure this path points to your file
        window.open(fileUrl, "_blank"); // Opens the file in a new tab
    };
    const handleFileDownload1= () => {
        const fileUrl = `${process.env.PUBLIC_URL}/Vendor Gen4 Site Guide V2.pdf`; // Ensure this path points to your file
        window.open(fileUrl, "_blank"); // Opens the file in a new tab
    };
    const handleFileDownload2 = () => {
        const fileUrl = `${process.env.PUBLIC_URL}/Vendor Training Guide Gen4.pdf`; // Ensure this path points to your file
        window.open(fileUrl, "_blank"); // Opens the file in a new tab
    };

    const handleFileDownload3 = () => {
        const fileUrl = `${process.env.PUBLIC_URL}/Employee User Training guide.pdf`; // Ensure this path points to your file
        window.open(fileUrl, "_blank"); // Opens the file in a new tab
    };




    return (
        <Box sx={{ padding: "10px" }}>
            {/* <a href={"/DashBoard"} style={{ textTransform: "capitalize", textDecoration: "none", color: "rgb(97, 169, 251)", padding: "10px" }} >{"<-- Back to dashboard"}</a> */}
            <p className='mt-3'
                style={{ fontSize: "30px", color: "#3E4A62", marginLeft: "20px" }}
            >
                Help Page
            </p>
            <Box sx={{ width: '100%', typography: 'body1', padding: "20px" }}>

                <Box sx={{ borderBottom: 0 }}>
                    <Tabs value={value} onChange={handleChange} aria-label="lab API tabs example">

                        <Tab label="Client Material" value={1} hidden={getOrgType()=="Vendor"||isEmployee === "true"}/> {/* Use number for value */}
                        <Tab label="Vendor Material" value={2}  hidden={getOrgType()=="Client"||getOrgType()=="Super Client"}/> {/* Use number for value */}
                        <Tab label="Terms and Conditions" value={3} /> {/* Use number for value */}
                        <Tab label="Statement of Privacy" value={4} /> {/* Use number for value */}
                        <Tab label="Contact Us" value={5} /> {/* Use number for value */}
                    </Tabs>
                </Box>
                <TabPanel value={value} index={1} hidden={getOrgType()=="Vendor"||isEmployee === "true"}> {/* Pass number for index */}
                    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                        {/* <p style={{ marginBottom: "16px", fontSize: "16px", color: "#333" }}>
                            <strong>1. Getting Started</strong><br />
                            Welcome to the First Verify help page! Here, you’ll find all the information you need to get started and use the application efficiently.
                        </p>
                        <h4 style={{ margin: "16px 0", fontSize: "18px", color: "#333" }}>Click the link below:</h4> */}
                        <a
                            onClick={handleFileDownload}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "16px",
                                textTransform: "capitalize",
                                textDecoration: "none",
                                color: "rgb(97, 169, 251)",
                                cursor: "pointer",
                                transition: "color 0.3s ease",marginBottom:"20px"
                            }}
                            onMouseEnter={(e) => e.target.style.color = "#0056b3"}
                            onMouseLeave={(e) => e.target.style.color = "rgb(97, 169, 251)"}
                        >
                            <InsertDriveFileIcon style={{ marginRight: "8px" }} />  Client training guide
                        </a>
                   

                        <a className="my-3 " href="https://youtu.be/RPDO8zj4FRM "    style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "16px",
                                textTransform: "capitalize",
                                textDecoration: "none",
                                color: "rgb(97, 169, 251)",
                                cursor: "pointer",
                                transition: "color 0.3s ease",marginBottom:"20px"
                            }}
                            onMouseEnter={(e) => e.target.style.color = "#0056b3"}
                            onMouseLeave={(e) => e.target.style.color = "rgb(97, 169, 251)"} target="_blank" rel="noopener noreferrer">
                        <PlayCircleIcon style={{ marginRight: "8px" }}/>  Client Training Video
                         </a>
                        {/* <div style={{ display: 'flex', justifyContent: 'center', margin: '20px' }}>
                            <iframe
                                width="560"
                                height="315"
                                src="https://www.youtube.com/embed/RPDO8zj4FRM"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            ></iframe>
                        </div> */}
                    </div>

                </TabPanel>
                <TabPanel value={value} index={2} hidden={getOrgType()=="Client"||getOrgType()=="Super Client"}>
                    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                        {/* <p style={{ marginBottom: "16px", fontSize: "16px", color: "#333" }}>
                            <strong>1. Getting Started</strong><br />
                            Welcome to the First Verify help page! Here, you’ll find all the information you need to get started and use the application efficiently.
                        </p>
                        <h4 style={{ margin: "16px 0", fontSize: "18px", color: "#333" }}>Click the link below:</h4> */}
                        <a
                            onClick={handleFileDownload1}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "16px",
                                textTransform: "capitalize",
                                textDecoration: "none",
                                color: "rgb(97, 169, 251)",
                                cursor: "pointer",
                                transition: "color 0.3s ease"
                            }}
                            onMouseEnter={(e) => e.target.style.color = "#0056b3"}
                            onMouseLeave={(e) => e.target.style.color = "rgb(97, 169, 251)"}
                            hidden={getOrgType()=="Client"||isEmployee === "true"}
                        >
                            <InsertDriveFileIcon style={{ marginRight: "8px" }} /> Vendor site guide
                        </a>
                        <a
                            onClick={handleFileDownload2}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "16px",
                                textTransform: "capitalize",
                                textDecoration: "none",
                                color: "rgb(97, 169, 251)",
                                cursor: "pointer",
                                transition: "color 0.3s ease"
                            }}
                            onMouseEnter={(e) => e.target.style.color = "#0056b3"}
                            onMouseLeave={(e) => e.target.style.color = "rgb(97, 169, 251)"}
                            hidden={getOrgType()=="Client"||isEmployee === "true"}
                        >
                            <InsertDriveFileIcon style={{ marginRight: "8px" }} /> Vendor training management guide
                        </a>
                        <a
                            onClick={handleFileDownload3}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "16px",
                                textTransform: "capitalize",
                                textDecoration: "none",
                                color: "rgb(97, 169, 251)",
                                cursor: "pointer",
                                transition: "color 0.3s ease",marginBottom:"20px"
                            }}
                            onMouseEnter={(e) => e.target.style.color = "#0056b3"}
                            onMouseLeave={(e) => e.target.style.color = "rgb(97, 169, 251)"}
                        >
                            <InsertDriveFileIcon style={{ marginRight: "8px" }} /> Vendor employee - completing training guide
                        </a>


                        {/* <a className="my-3 mx-2" href="https://youtu.be/n357_lLBnwo" target="_blank" rel="noopener noreferrer">https://youtu.be/RPDO8zj4FRM </a> */}

                        <a className="my-3 " href="https://youtu.be/n357_lLBnwo"    style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "16px",
                                textTransform: "capitalize",
                                textDecoration: "none",
                                color: "rgb(97, 169, 251)",
                                cursor: "pointer",
                                transition: "color 0.3s ease",marginBottom:"20px"
                            }}
                            hidden={getOrgType()=="Client"||isEmployee === "true"}
                            onMouseEnter={(e) => e.target.style.color = "#0056b3"}
                            onMouseLeave={(e) => e.target.style.color = "rgb(97, 169, 251)"} target="_blank" rel="noopener noreferrer">
                        <PlayCircleIcon style={{ marginRight: "8px" }}/>  Vendor Training Video
                         </a>
                        {/* <div style={{ display: 'flex', justifyContent: 'center', margin: '20px' }}>
                            <iframe
                                width="560"
                                height="315"
                                src="https://www.youtube.com/embed/n357_lLBnwo"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            ></iframe>
                        </div> */}
                    </div>


                </TabPanel>
                <TabPanel value={value} index={3}>
                    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                        <Terms_and_Conditions />
                    </div>
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                        <Statement_of_Privacy />
                    </div>
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                        {/* <Contact_us/> */}

                        <div
                            style={{
                                backgroundColor: '#f9f9f9',
                                borderRadius: '8px',
                                padding: '20px',
                                maxWidth: '600px',
                                margin: '0 auto',
                                fontFamily: 'Arial, sans-serif',
                            }}
                        >

                            <p
                                style={{
                                    fontSize: '1.1em',
                                    color: '#333',
                                    lineHeight: '1.6',
                                    marginBottom: '20px',
                                }}
                            >
                                If you are having issues with any portion of the website, please use the contact information below to obtain assistance.
                            </p>
                            <div style={{ marginTop: '20px' }}>
                                <p
                                    style={{
                                        fontSize: '1.1em',
                                        color: '#333',
                                        lineHeight: '1.6',
                                        marginBottom: '10px',
                                    }}
                                >
                                    <strong style={{ fontWeight: 'bold', marginRight: '5px' }}>
                                        Email:
                                    </strong>
                                    <a
                                        href="mailto:support@firstverify.com"
                                        style={{ color: '#007BFF', textDecoration: 'none' }}
                                        onMouseOver={(e) => (e.target.style.textDecoration = 'underline')}
                                        onMouseOut={(e) => (e.target.style.textDecoration = 'none')}
                                    >
                                        support@firstverify.com
                                    </a>
                                </p>
                                <p
                                    style={{
                                        fontSize: '1.1em',
                                        color: '#333',
                                        lineHeight: '1.6',
                                        marginBottom: '10px',
                                    }}
                                >
                                    <strong style={{ fontWeight: 'bold', marginRight: '5px' }}>
                                        Phone:
                                    </strong>
                                    <a
                                        href="tel:4025625930"
                                        style={{ color: '#007BFF', textDecoration: 'none' }}
                                        onMouseOver={(e) => (e.target.style.textDecoration = 'underline')}
                                        onMouseOut={(e) => (e.target.style.textDecoration = 'none')}
                                    >
                                        402-562-5930
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </TabPanel>
            </Box>
        </Box>
    );
}
